import React from 'react'
import Section from '../Section'
import s from './PageLinks.scss'
import { Link } from 'react-router'
import { CmsIcon } from 'features/Cms/CmsIcon'

export default props => (
  <Section
    color={props.color}
    fullHeight={props.fullHeight}
    paddingTop={0}
    paddingBottom={0}
    sectionWidth={props.sectionWidth}
    style={props.centerText ? { textAlign: 'center' } : {}}
    pattern={props.pattern}
  >
    <div className={s.links}>
      {props.links.map(item => (
        <Link key={item.label} to={item.to} className={s.link} activeClassName={s.active}>
          {item.icon && <CmsIcon name={item.icon} size="80" />}
          {item.image && <img src={item.image} />}
          {item.label}
        </Link>
      ))}
    </div>
  </Section>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/PageLinks/PageLinks.jsx